<script>
  import { onMount } from 'svelte';
  export let Style;
  import 'quill-mention';
  import { client } from 'root/api/index.js';

  let editor;

  export let toolbarOptions = [
    [
      { header: 1 },
      { header: 2 },
      'blockquote',
      'bold',
      'italic',
      'underline',
      'strike',
      { list: 'ordered' },
      { list: 'ordered' },
      { align: [] },
    ],
  ];
  let quill;
  let id = 77;
  onMount(async () => {
    const { default: Quill } = await import('quill');
    quill = new Quill(editor, {
      modules: {
        toolbar: toolbarOptions,
        mention: {
          allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
          mentionDenotationChars: ['@'],
          source: async function (searchTerm, renderList) {
            if (searchTerm.trim() != '') {
              client
                .taskSearch({
                  searchKeyword: searchTerm,
                  clientId: id,
                })
                .then((response) => {
                  let whitelist = response.data.map((item) => {
                    item.value = item.name;
                    return item;
                  });
                  renderList(whitelist);
                });
            }
          },
        },
      },
      theme: 'snow',
      placeholder: 'Enter your comments here...',
    });
  });
</script>

<button
  on:click={() => {
    var editor_content = quill.container.innerHTML;
  }}>Get Div</button
>
<button
  on:click={() => {
    var editor_content = quill.container.firstChild.innerHTML;
  }}>Get Html Only</button
>
<button on:click={() => {}}>Get Array Only</button>
<button
  on:click={() => {
    quill.setContents('');
  }}>Reset</button
>
<div class="background-white text-editor editor-wrapper {Style}">
  <div bind:this={editor}>
    <slot></slot>
  </div>
</div>

<style lang="scss">
  :global(.ql-editor) {
    height: 474px !important;
  }
  :global(.text-editor.dark-mode) {
    background-color: var(--clr-base);
    border: 1px solid var(--input-border);
  }
  :global(.dark-mode .ql-toolbar.ql-snow),
  :global(.dark-mode .ql-container.ql-snow) {
    border: 1px solid var(--input-border);
  }
  :global(.dark-mode .ql-editor) {
    color: var(--light);
  }

  :global(
    .dark-mode .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before
  ) {
    color: var(--clr-base-lt) !important;
  }
  :global(.dark-mode .ql-snow .ql-stroke) {
    stroke: var(--clr-base-lt) !important;
  }

  :global(.ql-editor.ql-blank::before) {
    color: var(--clr-base-lt);
  }
  :global(.ql-editor a) {
    color: var(--clr-secondary);
  }
</style>
